import { User } from './User';

export interface Profile {
  user: User;
  // here additional settings like
  // - loaded ones by backend or
  // - personal local state configuration
}
